import { RootPaths } from "@src/appV2/App/paths";
import { useToast } from "@src/appV2/lib";
import { SHIFT_DISCOVERY_PATH } from "@src/appV2/redesign/ShiftDiscovery/paths";
import { useEffect } from "react";
import { Redirect } from "react-router-dom";

export function OrientationNotRequired() {
  const { showInfoToast } = useToast();

  useEffect(() => {
    showInfoToast("You are no longer required to take a Demo Shift.");
  }, [showInfoToast]);

  return <Redirect to={`${RootPaths.APP_V2_HOME}/${SHIFT_DISCOVERY_PATH}`} />;
}
